module.exports = __webpack_public_path__ + "assets/img/52c1f8b41ca3b97822232fcf59646f66.svg";